import { h } from '@stencil/core';

export const ConfirmationIcon = () => {
  return (
    <svg
      width="20"
      stroke-width="5.5"
      stroke-linecap="round"
      stroke="currentColor"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="none"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M30.9,5.9C16.8,5.9,5.4,17.4,5.4,31.5s11.4,25.6,25.5,25.6s25.5-11.5,25.5-25.6S45,5.9,30.9,5.9z" />
        <polyline points="16.6,26.1 30.5,40 59.8,10.7 " />
      </g>
    </svg>
  );
}